export const environment = {
    production: false,
    apiBaseUrl: 'API_BASE_URL',
    pageTitle: 'Dillianz - Marketplace',
    productId: 'default',
    line1: 'Contato: +55 11 4004-2879 ',
    line2: 'Endereço: Rua Uruguai, Edif. Albert Einstein, 421 - Centro, Passo Fundo - RS, 99010-110',
    line3: 'CNPJ: 47.698.516/0001-15',
    line4: 'Razão Social: DILLIANZ STORE LTDA',
    signUpUrl: 'https://banking.dillianz.com.br/account/signup',
    waterMark: true,
};
